import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=c3555096&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"
import style0 from "./page2.vue?vue&type=style&index=0&lang=less&"
import style1 from "./page2.vue?vue&type=style&index=1&id=c3555096&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3555096",
  null
  
)

export default component.exports